<section class="p-3">
  <h2 class="h3">Find an Existing Person</h2>
  <form [formGroup]="findAPersonForm" class="row row-cols-md-auto g-lg-3 g-md-2 align-items-start mb-3">
    <div class="col-12">
      <div class="row">
        <label for="personFilterType" class="required-field col-auto mb-2">Filter by:</label>
        <div class="col-auto mb-2">
          <select #filterTypeDD class="form-select form-select-sm" id="personFilterType" formControlName="FilterID">
            <option value="{{ null }}">Select person filter type</option>
            <option *ngFor="let filter of peopleService.personFilterTypes$ | async" value="{{filter.FilterColumnName}}">{{ filter.FilterDisplayValue }}</option>
          </select>
          <div class="invalid-feedback">Please select a filter type.</div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="['Name', 'DateOfBirth', 'SSN', 'PhoneNumber'].indexOf(findAPersonForm.get('FilterID').value) == -1">
      <label for="personFilterInput" class="visually-hidden">Filter text:</label>
      <input id="personFilterInput" formControlName="FilterInput" type="text" class="form-control form-control-sm mb-2" />
    </div>
    <div class="col-12" *ngIf="findAPersonForm.get('FilterID').value === 'Name'">
      <div class="row">
        <label for="FirstName" class="col-auto mb-2">First name:</label>
        <div class="col-auto mb-2"><input id="FirstName" type="text" formControlName="FilterFirstNameInput" class="form-control form-control-sm" /></div>
      </div>
      <div class="row">
        <label for="LastName" class="col-auto mb-2">Last name:</label>
        <div class="col-auto mb-2"><input id="LastName" type="text" formControlName="FilterLastNameInput" class="form-control form-control-sm" /></div>
      </div>
    </div>
    <div class="col-12" *ngIf="findAPersonForm.get('FilterID').value === 'DateOfBirth'">
      <label for="FilterDate" class="visually-hidden">Filter date</label>
      <p-calendar inputId="FilterDate" formControlName="FilterDate" [showIcon]="true" icon="far fa-calendar-alt" inputStyleClass="form-control form-control-sm mb-2" [showOnFocus]="false"></p-calendar>
    </div>
    <div class="col-12" *ngIf="findAPersonForm.get('FilterID').value === 'SSN'">
      <label for="FilterSSN" class="visually-hidden">Filter SSN</label>
      <p-inputMask inputId="FilterSSN" formControlName="FilterSSN" mask="999-99-9999" styleClass="form-control form-control-sm mb-2"></p-inputMask>
    </div>
    <div class="col-12" *ngIf="findAPersonForm.get('FilterID').value === 'PhoneNumber'">
      <label for="FilterPhoneNumber" class="visually-hidden">Filter Phone Number</label>
      <p-inputMask inputId="PhoneNumber" formControlName="FilterPhoneNumber" mask="(999) 999-9999" styleClass="form-control form-control-sm mb-2" [ariaRequired]="true" [maxlength]="80" [autoClear]="false"></p-inputMask>
    </div>
    <div class="col-12">
      <button type="button" class="btn btn-sm btn-success mb-2" (click)="onSearchPerson()" [disabled]="!findAPersonForm.valid"><i class="fas fa-search" aria-hidden="true"></i> Find</button>
    </div>
  </form>
  <div class="my-3">
    <p-table #dt [value]="findPeopleResults" [columns]="peopleSearchResultTableCols" selectionMode="single" [(selection)]="selectedPeople" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="rows" [autoLayout]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div class="p-2 fw-bold text-center">Find Existing People Result</div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" scope="col" [pSortableColumn]="col.field">
            {{col.header}} <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td>
            <button type="button" tabindex="0" class="btn btn-link" aria-label="{{'Person '+rowData.LastName+' details'}}" (click)="viewPersonDetails(rowData)">{{rowData.LastName}}</button>
          </td>
          <td>{{rowData.FirstName}}</td>
          <td>{{rowData.DateOfBirth | date:"MM/dd/yyyy" }}</td>
          <td>{{rowData.SSN | ssnFormat}}</td>
          <td>
            <div *ngFor="let fbiNum of rowData.ENESS_XREF_PeopleFBIFileNumbers">
              {{fbiNum.FBIFileNumber}}
            </div>
          </td>
          <td>
            <div *ngFor="let stateId of rowData.ENESS_XREF_PeopleStateIDNumbers">
              {{stateId.StateAbbreviation?.concat(':')}} {{ stateId.StateIDNumbers}}
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No person found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="card my-3" *ngIf="defendantInfoForm">
    <div class="card-body" [formGroup]="defendantInfoForm">
      <input type="hidden" formControlName="PersonID" />
      <div class="row my-3" formGroupName="ENESS_Person">
        <div class="form-group col-lg-6">
          <label for="FirstName">First Name</label>
          <input id="FirstName" type="text" formControlName="FirstName" class="form-control form-control-plaintext" />
        </div>
        <div class="form-group col-lg-6">
          <label for="LastName">Last Name</label>
          <input id="LastName" type="text" formControlName="LastName" class="form-control form-control-plaintext" />
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group col-lg">
          <div class="label required-field me-3">Adjudication Status</div>
          <ng-container *ngIf="resultService.adjudicationStatuses$ | async as adjudicationStatuses">
            <div class="form-check form-check-inline" *ngFor="let adjudicationStatus of adjudicationStatuses;let i = index">
              <input class="form-check-input" type="radio" name="SuccessStoryAdjudicationStatusID" formControlName="SuccessStoryAdjudicationStatusID" id="{{'AdjudicatedStatus'+i}}" [value]="adjudicationStatus.SuccessStoryAdjudicationStatusID">
              <label class="form-check-label" for="{{'AdjudicatedStatus'+i}}">{{ adjudicationStatus.SuccessStoryAdjudicationStatus }}</label>
            </div>
            <div class="cross-validation-feedback" *ngIf="defendantInfoForm?.get('SuccessStoryAdjudicationStatusID').invalid">
              Please provide the adjudication status.
            </div>
          </ng-container>
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group col-lg-6">
          <label for="SuccessStoryProsecutionTypeID" class="{{defendantInfoForm?.get('SuccessStoryAdjudicationStatusID').value == adjudicationStatus?.SuccessStoryAdjudicationStatusID ? 'required-field' : ''}}">Prosecution Type</label>
          <select id="SuccessStoryProsecutionTypeID" class="form-control" formControlName="SuccessStoryProsecutionTypeID">
            <option value="">Select prosecution type</option>
            <ng-container *ngIf="resultService.prosecutionTypes$ | async as prosecutionTypes;else loadingTypes">
              <option *ngFor="let prosecutionType of prosecutionTypes" value="{{prosecutionType.SuccessStoryProsecutionTypeID}}">{{prosecutionType.SuccessStoryProsecutionType}}</option>
            </ng-container>
            <ng-template #loadingTypes><option>Loading prosecution types...</option></ng-template>
          </select>
        </div>
        <div class="form-group col-lg-6" [hidden]="!isStateProsecution">
          <label for="StateProsecutionID" class="required-field">State</label>
          <select id="StateProsecutionID" class="form-control" formControlName="StateID">
            <option value="">Select state</option>
            <ng-container *ngIf="lookupService.usStates$ | async as usStates">
              <option *ngFor="let state of usStates" value="{{state.StateID}}">{{state.StateName}}</option>
            </ng-container>
          </select>
        </div>
        <div class="form-group col-lg-6" [hidden]="!isJudicialDistrict">
          <label for="JudicialDistrictID" class="required-field">Judicial Districts</label>
          <select id="JudicialDistrictID" class="form-control" formControlName="JudicialDistrictID">
            <option value="">Select judicial districts</option>
            <option *ngFor="let districts of judicialDistricts" value="{{districts.JudicialDistrictID}}">{{districts.JudicialDistrict}}</option>
          </select>
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group col-lg-6">
          <label class="d-block" for="ArrestDate">Arrest Date</label>
          <p-calendar inputId="ArrestDate" formControlName="ArrestDate" [showIcon]="true" (onBlur)="onArrestDateBlur($event['target']['value'])" styleClass="w-100" inputStyleClass="form-control" [showOnFocus]="false" [maxDate]="maxDateRule"></p-calendar>
          <div class="invalid-feedback">
            Please provide the date and time the arrest occurred.
          </div>
        </div>
        <div class="form-group col-lg-6">
          <label class="d-block" for="ConvictionDate">Conviction Date</label>
          <p-calendar inputId="ConvictionDate" formControlName="ConvictionDate" [showIcon]="true" (onBlur)="onConvictionDateBlur($event['target']['value'])" styleClass="w-100" inputStyleClass="form-control" [showOnFocus]="false" [maxDate]="maxDateRule"></p-calendar>
          <div class="invalid-feedback">
            Please provide the date the conviction occurred.
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group col-lg-6">
          <label class="d-block" for="SentencingDate">Sentence Date</label>
          <p-calendar inputId="SentencingDate" formControlName="SentencingDate" [showIcon]="true" (onBlur)="onSentenceDateBlur($event['target']['value'])" styleClass="w-100" inputStyleClass="form-control" [showOnFocus]="false" [maxDate]="maxDateRule"></p-calendar>
          <div class="invalid-feedback">
            Please provide the date the sentence occurred.
          </div>
        </div>
        <div class="form-group col-lg-6">
          <label for="SentenceInMonths">Sentence (In Months)</label>
          <input id="SentenceInMonths" type="text" keydown="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" formControlName="SentenceInMonths" class="form-control" />
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group  col-lg">
          <label for="NumberOfShootingsChargedOrIndicted"># Shootings Charged/Indicted:</label>
          <input id="NumberOfShootingsChargedOrIndicted" formControlName="NumberOfShootingsChargedOrIndicted" type="number" max="999" min="0" class="form-control col-md-3" (change)="valueRangeCheck()" />
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group col-lg">
          <label for="Charges">Charges (1000 chars max)</label>
          <input id="Charges" formControlName="Charges" class="form-control" maxlength="1000" />
        </div>
      </div>
      <div class="row my-3">
        <div class="col-lg">
          <button type="button" [disabled]="defendantInfoForm.invalid || !this._defendant" (click)="onSaveDefendant()" class="btn btn-sm btn-success my-3 me-3" label="Save Defendant">Save Defendant</button>
          <button type="button" (click)="onClose()" class="btn btn-sm btn-success my-3">Close</button>
        </div>
      </div>
    </div>
  </div>
</section>
